import { useEffect } from "react";
import { TbX } from "react-icons/tb";
import IconCircle from "./IconCircle";
import PropTypes from "prop-types";

export default function Toast({ message, onClose, type = "success" }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const styleMap = {
    success: {
      bg: "bg-teal-50",
      border: "border-teal-200",
      text: "text-teal-900",
    },
    error: {
      bg: "bg-red-50",
      border: "border-red-200",
      text: "text-red-900",
    },
  };

  const styles = styleMap[type] || styleMap.success;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] animate-fade-in">
      <div className="rounded-md p-1.5 card-base bg-white shadow-lg">
        <div
          className={`${styles.bg} ${styles.border} ${styles.text} border rounded-md px-5 py-3 flex items-center gap-3 min-w-[300px] justify-between`}
        >
          <span className="font-medium">{message}</span>
          <button className="cursor-pointer" onClick={onClose}>
            <IconCircle icon={TbX} onClick={onClose} />
          </button>
        </div>
      </div>
    </div>
  );
}

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.string,
};
